import { useTranslation } from 'react-i18next';
import Button from '@ingka/button';

import { PREFIX } from '../../../Skapa/constants/constants';
import { ButtonType } from '../../../Skapa/Button/Button';
import Text from '@ingka/text';
import styles from './MaintenanceMode.module.scss';

export const MaintenanceMode = ({ dismiss }: { dismiss: () => void }) => {
  const { t } = useTranslation('profile');

  return (
    <div className={styles.maintenanceContainer}>
      <Text prefix={PREFIX} textStyle="Heading.XL">
        {t('sheet.logIn.maintenance.heading')}
      </Text>
      <Text prefix={PREFIX} tagName="p" textStyle="Body.M">
        {t('sheet.logIn.maintenance.body')}
      </Text>
      <Button
        prefix={PREFIX}
        data-testid="maintenanceBtn"
        text={t('sheet.logIn.maintenance.buttonLabel')}
        type={ButtonType.PRIMARY}
        className={styles.maintenanceBtn}
        size="small"
        onClick={dismiss}
      />
      <div>
        <img src="https://asset.inter.ikea.com/images/PH179710_original?v=5a6d0cdf" alt="" />
      </div>
    </div>
  );
};
